export const ADD_MESSAGE: "snackbar/ADD_MESSAGE" = "snackbar/ADD_MESSAGE";
export const REMOVE_MESSAGE: "snackbar/REMOVE_MESSAGE" =
  "snackbar/REMOVE_MESSAGE";
export const REMOVE_MESSAGE_BY_INDEX: "snackbar/REMOVE_MESSAGE_BY_INDEX" =
  "snackbar/REMOVE_MESSAGE_BY_INDEX";
